// extracted by mini-css-extract-plugin
export default {"wrapper":"TableMenu_wrapper__WwQ2U","container":"TableMenu_container__0J7q9","text":"TableMenu_text__hQkUu"};